var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"my-back-btn",attrs:{"depressed":""}},[_c('img',{staticClass:"back-btn",attrs:{"src":_vm.$store.state.icons.icons['LeftArrow'],"alt":""}}),_vm._v(" Back ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }